import React from 'react';

export const DocumentationHiddenButton = ({ isAllDocumentsAccepted, onKeyDown }) => {
    const documentAcceptedClass = isAllDocumentsAccepted ? 'read' : '';

    return (
        <div
            role="button"
            tabIndex={0}
            className={`button-unset documentation  ${documentAcceptedClass}`}
            onKeyDown={onKeyDown}
        ></div>
    );
};
